export default function formatNumber(number, {precision} = {}) {
  const options = {
    maximumFractionDigits: precision,
    minimumFractionDigits: precision,
  }
  return Intl.NumberFormat(I18n.locale, options).format(number)
}
